import request from '@/util/request';

// 获取押金种类列表
export const getDepositTypeList = (params, options) =>
  request.get('/api/v4ward/property/deposit/list', Object.assign({}, options, { params }));

// 获取押金抵扣记录分页列表
export const getDepositDeductionPageList = (params, options) =>
  request.get('/api/v4ward/property/deposit/deduct/page', Object.assign({}, options, { params }));

// 获取押金抵扣附件
export const getDepositDeductionAttachList = (params, options) =>
  request.get('/api/v4ward/property/deposit/deduct/voucherList', Object.assign({}, options, { params }));

// 保存押金抵扣附件
export const saveDepositDeductionAttachList = (params, options) =>
  request.post('/api/v4ward/property/deposit/deduct/submitVoucher', params, options, {
    'Content-Type': 'application/json',
  });
